"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tree = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var TreeItem2_1 = require("@mui/x-tree-view/TreeItem2");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../Types");
var Tree = /** @class */ (function (_super) {
    __extends(Tree, _super);
    function Tree(props) {
        var _this = _super.call(this, props) || this;
        _this.itemId = _this.randomId();
        return _this;
    }
    Tree.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.defaultOpen) {
            this.treeManager.addOpen(this.itemId);
        }
        if (this.props.onItemToggle) {
            this.subscription = this.treeManager.subscribeToOpen((function (openIds) {
                if (_this.props.onItemToggle && openIds.includes(_this.itemId)) {
                    _this.props.onItemToggle();
                }
            }));
        }
    };
    Tree.prototype.componentWillUnmount = function () {
        var _a;
        (_a = this.subscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    };
    Tree.prototype.render = function () {
        return (0, jsx_runtime_1.jsx)(TreeItem2_1.TreeItem2, { id: this.props.id, className: this.props.className, label: this.props.label, itemId: this.itemId, children: this.props.children });
    };
    Tree.prototype.randomId = function (length) {
        if (length === void 0) { length = 8; }
        var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var result = '';
        for (var i = 0; i < length; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return result;
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.TreeManager),
        __metadata("design:type", Object)
    ], Tree.prototype, "treeManager", void 0);
    return Tree;
}(React.Component));
exports.Tree = Tree;
//# sourceMappingURL=Tree.js.map